import { FC } from 'react'

import { JsonLoader } from 'components/atoms/JsonLoader'

import { CardListRow, EmailAlertGroupPrefill } from '../processCatalogue'

import { CardListPager } from './CardListPager'
import { EmailAlertNotConfiguredCard } from './EmailAlertNotConfiguredCard'
import { EmailAlertPairedCard } from './EmailAlertPairedCard'
import {
  EmailAlertReportCard,
  NotificationRecipientCard,
} from './EmailAlertReportCard'

export interface EmailAlertsCardListProps {
  /** Rows for the current page only — paging is done by the caller (BDL20-4262). */
  rows: CardListRow[]
  isLoading: boolean
  partnerFilterIsAll: boolean
  canEdit: boolean
  onManageClick: (card: NotificationRecipientCard) => void
  onEditClick: (card: NotificationRecipientCard) => void
  onDeleteClick: (card: NotificationRecipientCard) => void
  onSetUpClick: (prefill: EmailAlertGroupPrefill) => void
  pageNumber: number
  take: number
  totalCount: number
  onPageChange: (page: number) => void
  onTakeChange: (take: number) => void
}

export const EmailAlertsCardList: FC<EmailAlertsCardListProps> = ({
  rows,
  isLoading,
  partnerFilterIsAll,
  canEdit,
  onManageClick,
  onEditClick,
  onDeleteClick,
  onSetUpClick,
  pageNumber,
  take,
  totalCount,
  onPageChange,
  onTakeChange,
}: EmailAlertsCardListProps) => {
  return (
    <div className='mt-4'>
      <div className='relative flex flex-col gap-3.5 min-h-[120px]'>
        {isLoading && (
          <div className='flex w-full h-full items-center justify-center bg-N-800 absolute z-[1] bg-opacity-10 cursor-not-allowed rounded-md'>
            <JsonLoader size='xxs' />
          </div>
        )}

        {!isLoading && rows.length === 0 && (
          <div className='border-[1.5px] border-dashed border-N-200 rounded-md px-[18px] py-6 text-center text-[13px] text-N-500'>
            No reports match the current filters.
          </div>
        )}

        {rows.map((row) => {
          if (row.kind === 'paired') {
            return (
              <EmailAlertPairedCard
                key={row.key}
                row={row}
                showPartnerLabel={partnerFilterIsAll}
                canEdit={canEdit}
                onManageClick={onManageClick}
                onEditClick={onEditClick}
                onDeleteClick={onDeleteClick}
                onSetUpClick={onSetUpClick}
              />
            )
          }
          if (row.kind === 'missing') {
            return (
              <EmailAlertNotConfiguredCard
                key={row.key}
                row={row}
                showPartnerLabel={partnerFilterIsAll}
                canEdit={canEdit}
                onSetUpClick={onSetUpClick}
              />
            )
          }
          return (
            <EmailAlertReportCard
              key={row.key}
              card={row.card}
              showPartnerLabel={partnerFilterIsAll}
              canEdit={canEdit}
              onManageClick={onManageClick}
              onEditClick={onEditClick}
              onDeleteClick={onDeleteClick}
            />
          )
        })}
      </div>

      {totalCount > 0 && (
        <CardListPager
          pageNumber={pageNumber}
          take={take}
          totalCount={totalCount}
          onPageChange={onPageChange}
          onTakeChange={onTakeChange}
        />
      )}
    </div>
  )
}

export default EmailAlertsCardList
